import PropTypes from 'prop-types';
import React from 'react'
import { browserHistory, Link } from 'react-router-dom'


export default class extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired
	};

    render() {

		return (
		
			<Link to="/me" className="text-white">
				{( this.props.user.profile_picture
					? <div className="profile-image" style={{
						backgroundImage: 'url(' + this.props.user.profile_picture + ')'
					}}></div>
					: 'Me'
				)}
			</Link>
			
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Header/components/UserDropdown.js